import { render, staticRenderFns } from "./screenVideoView.vue?vue&type=template&id=6938c7ee&scoped=true&"
import script from "./screenVideoView.vue?vue&type=script&lang=js&"
export * from "./screenVideoView.vue?vue&type=script&lang=js&"
import style0 from "./screenVideoView.vue?vue&type=style&index=0&id=6938c7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938c7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6938c7ee')) {
      api.createRecord('6938c7ee', component.options)
    } else {
      api.reload('6938c7ee', component.options)
    }
    module.hot.accept("./screenVideoView.vue?vue&type=template&id=6938c7ee&scoped=true&", function () {
      api.rerender('6938c7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/screenVideoView.vue"
export default component.exports